import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const MatchButton = (props) => {
  return (
    <Chip
      label="Match"
      component={Link}
      to={"/match/" + props.matchId}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default MatchButton;
